/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Share_Save_ErrorInputs */

const en_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error saving share. ${i?.message}`)
};

const fr_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de l’enregistrement du partage. ${i?.message}`)
};

const de_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern der Freigabe. ${i?.message}`)
};

const it_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il salvataggio della condivisione. ${i?.message}`)
};

const ru_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка сохранения общего ресурса. ${i?.message}`)
};

const es_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al guardar el recurso compartido. ${i?.message}`)
};

const zh_cn2_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存分享时出错。${i?.message}`)
};

const ja_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共有の保存中にエラーが発生しました。${i?.message}`)
};

const hi_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शेयर सहेजने में त्रुटि। ${i?.message}`)
};

const pt_pt2_team_share_save_error = /** @type {(inputs: Team_Share_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao salvar o compartilhamento. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error saving share. {message}" |
*
* @param {Team_Share_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_save_error = /** @type {((inputs: Team_Share_Save_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Save_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_save_error(inputs)
	if (locale === "de") return de_team_share_save_error(inputs)
	if (locale === "it") return it_team_share_save_error(inputs)
	if (locale === "ru") return ru_team_share_save_error(inputs)
	if (locale === "es") return es_team_share_save_error(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_save_error(inputs)
	if (locale === "ja") return ja_team_share_save_error(inputs)
	if (locale === "hi") return hi_team_share_save_error(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_save_error(inputs)
	return en_team_share_save_error(inputs)
});